import { ScrollRestoration, useParams } from '@tanstack/react-router';
import React from 'react';
import { z } from 'zod';

import { ContractTerms } from '@/pages/club/onboard/components/stages/contract-terms';
import { Photo } from '@/pages/club/onboard/components/stages/photo';
import { WorkingConditions } from '@/pages/club/onboard/components/stages/working-conditions';

import { Housing } from './components/stages/housing';
import { Payments } from './components/stages/payments';
import { Penalties } from './components/stages/penalties';
import { Schedule } from './components/stages/schedule';
import { Video } from './components/stages/video';

export const clubOnBoardingStages = z.enum([
  'schedule',
  'contract-terms',
  'payments',
  'work-conditions',
  'housing',
  'penalties',
  'photo',
  'video'
]);

type Stages = z.infer<typeof clubOnBoardingStages>;

const component: Record<Stages, React.ReactNode> = {
  schedule: <Schedule />,
  'contract-terms': <ContractTerms />,
  payments: <Payments />,
  'work-conditions': <WorkingConditions />,
  housing: <Housing />,
  penalties: <Penalties />,
  photo: <Photo />,
  video: <Video />
};

export const ClubOnBoarding = () => {
  const { step } = useParams({ from: '/clubOwner/$id/_onboard/onboard/$step' });

  return (
    <div>
      <ScrollRestoration />
      {component[step]}
    </div>
  );
};
